module.exports = __webpack_public_path__ + "static/media/UrbanColors_1.c39e4a95.jpg";